import type { VisitsFilter } from "@gettactic/api";
import type { DateRange } from "@gettactic/components/src/calendar/types";
import { endOfDay, format, startOfDay } from "date-fns";
import type { VisitorStatus, VisitorTab } from "./VisitorsContext";

export interface VisitsFilterParamsInput {
  activeTab: VisitorTab;
  officeIds: string[];
  hostId: string;
  searchText: string;
  dateRange: DateRange;
  statusFilter: VisitorStatus;
  timeZone: string;
  today: Date;
}

/**
 * Builds the visits list query for a tab of the Visitors page. The Visitor Log
 * and Pre-registered tabs share one date range; a range with only its start
 * picked covers that single day.
 */
export const buildVisitsFilterParams = ({
  activeTab,
  officeIds,
  hostId,
  searchText,
  dateRange,
  statusFilter,
  timeZone,
  today
}: VisitsFilterParamsInput): VisitsFilter => {
  const params: VisitsFilter = {
    office_id: officeIds.length === 1 ? officeIds[0] : undefined,
    host_id: hostId || undefined,
    search: searchText || undefined,
    limit: 100,
    tz: timeZone
  };

  if (activeTab === "upcoming") {
    params.status = "expected";
    params.date_from = format(startOfDay(today), "yyyy-MM-dd");
    return params;
  }

  if (dateRange.from) {
    params.date_from = format(startOfDay(dateRange.from), "yyyy-MM-dd");
    params.date_to = format(
      endOfDay(dateRange.to ?? dateRange.from),
      "yyyy-MM-dd"
    );
  }

  if (activeTab === "preregistered") {
    params.status = "expected";
  } else if (statusFilter !== "all") {
    params.status = statusFilter;
  }

  return params;
};
